import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

/**
 * Confirmation dialog for sending a password-reset email.
 * @param {{open?: boolean, user?: any, onClose?: ()=>void, onConfirm?: (user:any)=>void}} props
 */
export default function UserResetDialog({ open = false, user = null, onClose, onConfirm }) {
  const handleConfirm = () => {
    onConfirm && onConfirm(user);
  };

  return (
    <Dialog open={!!open} onClose={onClose} disableScrollLock>
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you want to send a password reset email to{' '}
          {user?.firstName || ''} {user?.lastName || ''}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
